































import {Component, Vue, Prop, Mixins, Watch} from 'vue-property-decorator';
import NiceCheckbox from "./NiceCheckbox.vue";
import {Mixin} from "@/mixins";
import store from "@/store";

@Component({
    components: {
        NiceCheckbox
    },
    name: "AdditionalOptions",
})
export default class AdditionalOptions extends Mixins(Mixin) {
    store = store();

    @Watch('store.serverData.additionalOptions.trustedShops')
    onTrustedShopsChange(val: boolean): void {
        this.store.syncServer();
    }

    get showTrustedShops() {
      return typeof this.store.serverData.additionalOptions.trustedShops !== 'undefined'
          && this.store.serverData.additionalOptions.trustedShops === true;
    }
}
